import React from 'react';
import { useParams } from 'react-router-dom';
import EvalutionOfMalePartner from './EvaluationOfMalePartner';
import ExaminationOfMalePartner from './ExaminationOfMalePartner';
import InvestigationOfFemalePartner from './InvestigationOfFemalePartner';
import ExaminationOfFemalePartner from './ExaminationOfFemalePartner';
import { useDispatch, useSelector } from 'react-redux';
const PatientExaminationAndEvaluation = () => {
  const { id: patientId } = useParams();
  const patientData = useSelector((state) => state.clinicalReducer);


  return (
    <div className="theme-blush">
      <div className="container-fluid examination-form">
        <ExaminationOfFemalePartner />

        <InvestigationOfFemalePartner />
        <EvalutionOfMalePartner />

        <ExaminationOfMalePartner />
      </div>
      {/* <div className="d-flex justify-content-center">
        <button className="btn btn-primary" onClick = {examinationHandler}>
                Next
        </button>
      </div> */}
      
    </div>
  );
};

export default PatientExaminationAndEvaluation;
